// extracted by mini-css-extract-plugin
var _1 = "PageClassCards__item--I0RfR";
var _2 = "PageClassCards__logo--CLj8z";
var _3 = "PageClassCards__main--ffRmu";
var _4 = "PageClassCards__student--evO9l";
export { _1 as "item", _2 as "logo", _3 as "main", _4 as "student" }
